module.exports = __webpack_public_path__ + "static/img/office (13).ecc4680e.jpg";